/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderState
 */
export interface ProviderState {
    /**
     * 
     * @type {string}
     * @memberof ProviderState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderState
     */
    disabled?: boolean;
}

export function ProviderStateFromJSON(json: any): ProviderState {
    return ProviderStateFromJSONTyped(json, false);
}

export function ProviderStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function ProviderStateToJSON(value?: ProviderState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


